module.exports = __webpack_public_path__ + "57e85924316709f1fb11058b94811066.woff";